import React from "react";
import { useState } from "react";
import { Button, Flex, notification, Typography } from "antd";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import { useEffect } from "react";
import { api } from "../utils/Api";
import axios from "axios";
import dayjs from "dayjs";
import * as XLSX from "xlsx";

const { Text } = Typography;

const JobPerformanceLoads = ({ job }) => {
	const [loads, setLoads] = useState([]);
	const [loading, setLoading] = useState(true);

	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Load",
			dataIndex: "loadId",
			key: "loadId",
			render: (value, record) => {
				return <Text strong>{value}</Text>;
			},
		},
		{
			title: "Truck",
			dataIndex: "truck",
			key: "truck",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Loaded",
			dataIndex: "loaded",
			key: "loaded",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "To Job",
			dataIndex: "toJob",
			key: "toJob",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Arrive Job",
			dataIndex: "arriveJob",
			key: "arriveJob",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Start Unload",
			dataIndex: "startUnload",
			key: "startUnload",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Start Unload",
			dataIndex: "finishUnload",
			key: "finishUnload",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
	];

	const generatePDF = async (id) => {
		try {
			const url = api + `/job/generate/performance/pdf/${id}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.post(url);
			if (data.success) {
				const pdfUrl = data.payload;

				const link = document.createElement("a");
				link.href = pdfUrl;
				link.target = "_blank";
				link.rel = "noopener noreferrer";
				link.click();
				openNotification("success", "Success", data.message);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			openNotification("error", "Error", err.message);
			console.error(err.message);
			return null;
		}
	};

	const exportExcel = () => {
		const data = [
			["Job ID", job.jobId],
			["Client", job.client],
			["Time", job.dateTime],
			[],
			[
				"",
				"Truck",
				"Loaded",
				"To Job",
				"Arrive Job",
				"Start Unload",
				"Finish Unload",
			],
		];

		loads.forEach((load, index) => {
			data.push([
				load.loadId,
				load.truck,
				load.loaded,
				load.toJob,
				load.arriveJob,
				load.startUnload,
				load.finishUnload,
			]);
		});

		const ws = XLSX.utils.aoa_to_sheet(data);

		ws["!cols"] = [
			{ wch: 15 },
			{ wch: 10 },
			{ wch: 20 },
			{ wch: 20 },
			{ wch: 20 },
			{ wch: 20 },
			{ wch: 20 },
		];

		const wb = XLSX.utils.book_new();

		XLSX.utils.book_append_sheet(wb, ws, "Loads");

		XLSX.writeFile(wb, `Job Performance ${job.jobId}.xlsx`);
	};

	useEffect(() => {
		getLoads();
	}, []);

	const getLoads = async () => {
		try {
			setLoading(true);
			const url = api + `/load/${job.key}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);

			setLoads(
				data.map((item) => ({
					key: item._id,
					toJob: item.toJobDate
						? dayjs(item.toJobDate).add(5, "hour").format("MM/DD/YYYY HH:mm A")
						: "-",
					arriveJob: item.toArriveDate
						? dayjs(item.toArriveDate)
								.add(5, "hour")
								.format("MM/DD/YYYY HH:mm A")
						: "-",
					startUnload: item.startUnloadDate
						? dayjs(item.startUnloadDate)
								.add(5, "hour")
								.format("MM/DD/YYYY HH:mm A")
						: "-",
					finishUnload: item.finishUnloadDate
						? dayjs(item.finishUnloadDate)
								.add(5, "hour")
								.format("MM/DD/YYYY HH:mm A")
						: "-",
					loaded: dayjs(item.date).format("MM/DD/YYYY HH:mm A"),
					loadId: item.deliveryTicket,
					truck: item.truckNumber,
				})),
			);

			setLoading(false);
		} catch (err) {
			openNotification("error", "Error", err.message);
			console.error(err.message);
			return null;
		}
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<div>
					<Text strong>Client: {job.client}</Text>
					<br />
					<Text strong>Time: {job.dateTime}</Text>
				</div>
				<Flex gap={8}>
					<Button
						tton
						type="primary"
						onClick={() => generatePDF(job.key)}
						icon={<FilePdfOutlined />}
						danger
						disabled={loads.length === 0}
					>
						PDF
					</Button>
					<Button
						tton
						type="primary"
						icon={<FileExcelOutlined />}
						onClick={exportExcel}
						disabled={loads.length === 0}
					>
						EXCEL
					</Button>
				</Flex>
				<CustomTable columns={columns} data={loads} isScroll={false} />
			</Flex>
		);
	};

	return (
		<div>
			{loading ? <CustomSpinner /> : <RenderTable />}
			{contextHolder}
		</div>
	);
};

export default JobPerformanceLoads;
